<template lang="html">
    <div class="dashboard-button" :class="{ 'disabled': disabled }" @click="toggleShowColumnChooser">
        <img :src="icon" width="25" height="25" alt="">
        <span class="title">Column Chooser</span>
    </div>
</template>
<script>
import icon from '@/images/column-chooser.svg';

export default {
    name: 'ColumnChooserButton',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {
    },
    data() {
        return {
            icon,
        };
    },
    methods: {
        toggleShowColumnChooser() {
            this.$store.commit('SET_SHOW_COLUMN_CHOOSER_POPUP', !this.$store.getters.GET_SHOW_COLUMN_CHOOSER_POPUP);
        },
    },
}
</script>
<style lang="css">
.dashboard-button:hover {
    background-color: var(--light-primary-color);
    color: black !important;
}

.dashboard-button {
    display: inline-flex;
    padding: 5px 5px;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 5px;
    border: 1px solid #C0669E;
    cursor: pointer;
    background-color: transparent;
    color: black;
    height: 25px;
    width: 100%;
    max-width: 150px;
    font-family: "ArtifaktElement";
    transition: all 0.1s ease-in-out;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    font-weight: 700;
}

.dashboard-button .title {
    color: #C0669E;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.dark-theme .dashboard-button {
    color: white;
}
</style>